module.exports = __webpack_public_path__ + "cancel.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/cancel.svg?color1=%23333333&color2=
// module id = 2182
// module chunks = 67